import { vars } from '../base/variables'
import { menuToggle } from '../functions/menu-toggle'

const initNav = () => {
	const toggleBtn = document.querySelector('.menu-toggle')
	menuToggle(toggleBtn, vars.body[0])
	const links = document.querySelectorAll('#main-navigation li a');
	links.forEach(li => {
		li.addEventListener('touchstart', (e) => {
			e.target.classList.add('groove');
		})
	});
}

const initFooterNav = () => {
	const f_teasers = document.querySelectorAll('.page-footer a.footer-teaser');
	f_teasers.forEach(t => {
		t.addEventListener('mouseover', (e) => {
			const h = '#' + t.getAttribute('data-teaser');
			const parent = t.parentNode.parentNode;
			parent.setAttribute('data-hash', h);
		});
	});
}

export { initFooterNav, initNav }